module.exports = __webpack_public_path__ + "static/img/db59ea63bacd498cf38e01f4a7d96319.edf1fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/db59ea63bacd498cf38e01f4a7d96319.jpg
// module id = zBul
// module chunks = 3